import * as yup from 'yup';
import { IUser, UserSchema } from '../../common';
import { IResident, ResidentSchema } from './IResident';

export const ResidentGroupSchema = yup.object({
  name: yup.string().required(),
  residents: yup.array(ResidentSchema).notRequired().default([]),
  user: UserSchema.required(),
  isDefault: yup.boolean().default(false),
});

export interface IResidentGroup {
  name: string;
  residents?: IResident[];
  user: IUser;
  isDefault?: boolean;
}

export const ResidentGroupCreateSchema = yup.object({
  name: yup.string().required(),
  residents: yup.array(yup.string().required()).notRequired().default([]),
  isDefault: yup.boolean().default(false),
  selectedHouseDivisionId: yup.string().notRequired().nullable(),
});

export interface IResidentGroupCreate {
  name: string;
  residents?: string[];
  isDefault?: boolean;
  selectedHouseDivisionId?: string | null;
}
